import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';

import { VacationAdminCompany } from '@app/gen/vacations';
import { UnitNode } from '@app/gen/settings';

import { UnitNodeLabeled } from '../../types';

@injectable()
export class VacationsMapper {
  constructor(private readonly format: FormatService) {}

  processVacationAdminCompanies(companies: VacationAdminCompany[]) {
    return companies.map(({ has_schedule_for_next_year, id, name }) => ({
      disabled: has_schedule_for_next_year,
      id,
      label: name,
      value: id,
    }));
  }

  processUnitsTree(node: UnitNode): UnitNodeLabeled {
    return {
      id: node.id,
      label: node.name,
      count: node.employee_count || 0,
      hasChildrenToLoad: node.is_parent,
      hasSeparateAbove: node.has_separate_above,
      isSeparate: node.is_separate,
      disabled: node.has_vacation_schedule,
      children: node.children
        ? node.children
            .map((child) => this.processUnitsTree(child))
            .filter((unit) => unit)
        : [],
    };
  }
}
